import * as React from 'react';

/**
 * Element slajdu dla Swipera w trybie `loop`, który oznacza klony slajdów
 * atrybutem `aria-hidden="true"` — umowa SEO, Załącznik nr 1 poz. 5.
 *
 * Pętla Swipera dokleja kopie pierwszych i ostatnich slajdów (klasa
 * `swiper-slide-duplicate`), żeby przewijanie było ciągłe. Dla czytnika ekranu
 * i robota wyszukiwarki to zdublowana treść. Swiper pozwala podmienić element
 * slajdu przez właściwość `tag`, a klasę klonu nadaje już przy renderowaniu po
 * stronie serwera — dzięki temu atrybut jest w pierwszej odpowiedzi HTML, bez
 * czekania na skrypt. Wariant z ustawianiem atrybutu po inicjalizacji Swipera
 * tego nie daje.
 *
 * Typy Swipera deklarują `tag` jako `string`, choć w kodzie trafia on wprost do
 * `React.createElement` — stąd `swiperSlideTag` do użycia w miejscu wywołania.
 */
export const SwiperSlideElement: React.ForwardRefExoticComponent<
  React.HTMLAttributes<HTMLDivElement> & React.RefAttributes<HTMLDivElement>
> = React.forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(
  (props: React.HTMLAttributes<HTMLDivElement>, ref: React.ForwardedRef<HTMLDivElement>): JSX.Element => {
    const isDuplicate: boolean = (props.className ?? '').includes('swiper-slide-duplicate');

    return <div ref={ref} {...props} aria-hidden={isDuplicate ? 'true' : props['aria-hidden']} />;
  }
);

SwiperSlideElement.displayName = 'SwiperSlideElement';

export const swiperSlideTag: string = SwiperSlideElement as unknown as string;
